/**
 * HAR HUSET KONSERTER? (agent D sitt `GET /v1/concerts/presence`, brukt av menyen.)
 *
 * «Konserter» dukker opp i menyen første gang huset lager en egen konsert (SPILLESTED-KONSERT §2,
 * «Byrå som arrangør»), eller når plattformen har slått på modulen for huset (`concertsModule`, 0456 —
 * gründerdashbordets bryter). Skjemaet står her og ikke i kontraktpakken fordi menyen bare trenger
 * de to feltene.
 *
 * Et avslag eller en feil er «nei»: en meny som manglet ett punkt til svaret kom er bedre enn en
 * meny som blinket med en feil.
 */
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { apiRequest } from '@/api/client';
import { CACHE } from '@/api/cache-tiers';
import { qk } from '@/api/query-keys';

const presenceSchema = z.object({
  hasConcerts: z.boolean(),
  concertsModule: z.boolean(),
  /* F24: byrået har solgte jobber — «Konserter» i menyen også uten modulen. */
  hasSoldGigs: z.boolean().optional(),
});

export function concertPresenceQueryOptions(orgId: string) {
  return {
    queryKey: qk.concertPresence(orgId),
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      apiRequest({ path: '/concerts/presence', schema: presenceSchema, signal }),
    ...CACHE.reference,
    retry: false,
  } as const;
}

export function useConcertPresence(orgId: string | null, enabled: boolean): boolean {
  const query = useQuery({
    ...concertPresenceQueryOptions(orgId ?? ''),
    enabled: enabled && orgId !== null,
  });
  return query.data?.hasConcerts === true || query.data?.concertsModule === true;
}
